import { render, staticRenderFns } from "./MenuPermissaoItem.vue?vue&type=template&id=59ec73e3&scoped=true"
import script from "./MenuPermissaoItem.vue?vue&type=script&lang=js"
export * from "./MenuPermissaoItem.vue?vue&type=script&lang=js"
import style0 from "./MenuPermissaoItem.vue?vue&type=style&index=0&id=59ec73e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ec73e3",
  null
  
)

export default component.exports